import { IControlBlock, clone, EModalType, IOutputReference, IControlLayoutPanel } from '../../helpers/';
import types from '../types';

export interface IControlBlockConfigState {
    controlBlock: IControlBlock;
    componentId: string;
    previousOutputBlocks: any;
    allOutputReferences: IOutputReference[];
}

export const initialState: IControlBlockConfigState = {
    controlBlock: null,
    componentId: null,
    previousOutputBlocks: {},
    allOutputReferences: null
};

const controlBlockConfigReducer = function (state: IControlBlockConfigState = initialState, action): IControlBlockConfigState {

    let stateClone: IControlBlockConfigState = clone(state);

    switch (action.type) {

        case types.UPDATE_CONTROL_BLOCK_DIALOG:
            stateClone = updateControlBlockDialog(stateClone, action.controlBlock);
            break;

        case types.TOGGLE_DIALOG:
            stateClone = toggleDialog(stateClone, action.openModal, action.componentId, action.controlBlock, action.previousOutputBlocks,
                action.allOutputReferences);
            break;

        case types.CREATE_LAYOUT_PANELS:
            stateClone = updateLayoutPanel(stateClone, action.componentId, action.layoutPanels);
            break;
    }

    return stateClone;

}

const toggleDialog = (state: IControlBlockConfigState, openModal: EModalType, componentId: string, controlBlock: IControlBlock, previousOutputBlocks: any,
    allOutputReferences: IOutputReference[]): IControlBlockConfigState => {

    if (openModal === EModalType.ControlBlockLooping) {

        state.controlBlock = controlBlock;
        state.componentId = componentId;
        state.previousOutputBlocks = previousOutputBlocks;
        state.allOutputReferences = allOutputReferences;

    }

    return state;

};

const updateControlBlockDialog = (state: IControlBlockConfigState, controlBlock: IControlBlock): IControlBlockConfigState => {

    state.controlBlock = controlBlock;

    return state;

}

const updateLayoutPanel = (state: IControlBlockConfigState, componentId: string, layoutPanels: IControlLayoutPanel[]): IControlBlockConfigState => {

    if (state.controlBlock)
        state.controlBlock.LayoutPanels = layoutPanels;

    return state;

};


export default controlBlockConfigReducer;


// WEBPACK FOOTER //
// ./source/ts/store/reducers/control-block-config.ts